import assign from 'lodash/assign';
import DispatchConstants from '../constants/DispatchConstants';

const initState = () => ({
    firstName: '',
    lastName: '',
    userName: '',
    applicationsEnabled: false,
    features: {
        canAccessAnalytics: false,
        canAccessBilling: false,
        canAccessContacts: false,
        canAccessFeedClaimAndConvert: false,
        canAccessMainAccountSettings: false,
        canAccessMainAnalytics: false,
        canAccessMainContacts: false,
        canAccessMainMessages: false,
        canAccessMainMyProperties: false,
        canAccessMainSecuritySettings: false,
        canAccessMessages: false,
        canAccessMultiFamilyResources: false,
        canAccessUserManagement: false,
        canAddListing: false,
        canRespondToReview: false,
        canUpdateListing: false,
        canAccessInvoicePayments: false,
    },
    paymentsAccessAllowed: false,
    loggedIn: false,
    isUserBlocked: false,
    hasStrongAuthentication: false,
    impersonatorEmail: '',
    impersonatorUserToken: '',
    userToken: '',
    email: '',
    phoneNumber: '',
    roles: [],
    sessionSecondsRemaining: 1800,
    summary: {
        activeListingCount: 0,
        totalListingCount: 0,
    },
    isEmailVerified: false,
    isEnterpriseCustomer: false,
    isMultifamilyCustomer: false,
    isTwoFactorAuthEnabled: false,
    isTwoFactorAuthenticated: false,
    originalServerSideRequestCookies: {},
    apiResponseServerSideRequestCookies: [],
});

const user = (state = initState(), action = {}) => {
    const { type, payload } = action;

    if (type === DispatchConstants.UPDATE_USER_INFO) {
        return assign({}, state, payload);
    }
    return state;
};

export default user;
